<h1 class="page__title my-5 h2" translate>smsadv_send_sms_title</h1>
<div class="my-5" [formGroup]="sendSmsAdvCampaignForm">
  <!-- title -->
  <div class="my-5">
    <h4 class="my-3" translate>common_title</h4>
    <div class="d-flex flex-column ">
      <input type="text" class="col-sm-6 form-control w-30" id="title-smsadv" formControlName="title" />
      <wsb-validation-error-msg [fc]="sendSmsAdvCampaignForm.get('title')"></wsb-validation-error-msg>
      <span class="my-2" style="font-size:14px" translate>sms_send_title_optional</span>
    </div>
  </div>
  <!-- sender setting -->
  <div class="my-5">
    <h4 class="my-3" translate>sender_sender</h4>
    <div class="d-flex" formGroupName="sender">
      <div>
        <ng-select
          [items]="agcomSenders"
          bindLabel="sender"
          formControlName="valueSender"
          (change)="setSenderForm($event)"
          class="col-sm-4 form-control w-30"
          style="padding-left: 214px"
        ></ng-select>
        <wsb-validation-error-msg [fc]="sendSmsAdvCampaignForm.get('sender.idSender')"></wsb-validation-error-msg>
      </div>

      <wsb-atlas-button
        class="btn-adv-sender"
        variant="primary"
        size="lg"
        label="in_sms_create_auto_agcom_management"
        (btnClick)="OpenSenderSettingModal()"
      ></wsb-atlas-button>
    </div>
  </div>
  <!-- Message -->
  <div class="my-5">
    <h4 class="my-3" translate>send_sms_text</h4>
    <div>
      <span class="my-2" style="font-size:14px" translate>sendadv_text_privacy_info</span>
    </div>
    <div class="send-sms-adv d-flex">
      <!-- Insert template -->
      <wsb-atlas-button
        class="send-smsadv-button margin-button"
        variant="primary"
        label="send_sms_insert_template"
        size="lg"
        (btnClick)="openModalInsertTemplate()"
      ></wsb-atlas-button>
      <!-- btn save template -->

      <wsb-atlas-button
        class="smsadv-btn-page margin-button"
        variant="primary"
        label="send_sms_save_template"
        size="lg"
        (btnClick)="btnSaveAsTemplate()"
      ></wsb-atlas-button>

      <!-- Add landing page  -->
      <wsb-atlas-button
        *ngIf="showBtnAddPageLanding"
        class="smsadv-btn-page margin-button"
        variant="primary"
        label="send_sms_pages_insert"
        size="lg"
        (btnClick)="btnAddLandingPage()"
      ></wsb-atlas-button>
    </div>
    <div class="smsadv-div-character">
      <wsb-sms-textarea
        [longMessageControlInput]="false"
        [showLongMessageInput]="false"
        [isSmsADV]="true"
        [isShowSmsEncoding]="false"
        #smsAdvEditorView
      ></wsb-sms-textarea>
    </div>
  </div>
  <!-- Sending time -->
  <div class="my-5">
    <div class="d-flex">
      <h4 class="mb-3 mt-5" translate>common_data_sent</h4>
      <div
        class="tooltip-custom border rounded-circle border-1"
        #tooltip="matTooltip"
        matTooltipPosition="above"
        matTooltipClass="tooltip-class"
        matTooltip="{{ 'smsadv_send_time_wo_info' | translate }}"
      >
        <p>?</p>
      </div>
    </div>
    <div class="d-flex">
      <div class="sms-adv-div-send-date">
        <span class="sms-adv-timing-label" style="margin-bottom: 3%" translate>common_data_sent</span>
        <wsb-atlas-datepicker
          [min]="minDate"
          [max]="maxDate"
          class="smsadv-date"
          format="date"
          [formControl]="sendDateFC"
          disableWE="true"
        ></wsb-atlas-datepicker>
      </div>
      <div class="sms-adv-div-time">
        <span class="sms-adv-timing-label" style="margin-bottom: 6%" translate>common_hours_sent</span>
        <input type="text" class="form-control" [formControl]="timeFC" [mask]="mask" style="height: 32px" />
        <span style="width:223%">
          <!-- <wsb-validation-error-msg [fc]="timeFC"></wsb-validation-error-msg> -->
        </span>
      </div>
    </div>
    <div class="px-1 col-8 text-wrap">
      <wsb-validation-error-msg [fc]="scheduledDate"></wsb-validation-error-msg>
    </div>
    <div style="margin-top:3px">
      <span style="font-size:14px" translate></span>
    </div>
  </div>
</div>

<!-- Sender Settigs  Modal -->
<ng-template #senderSettingModal let-c="close" let-d="dismiss">
  <wsb-modal
    title="{{ 'common_attention' | translate }}"
    (dismiss)="d()"
    (primary)="routeToSenderSettingPage()"
    primaryButtonText="common_confirm"
    cancelButtonEnable="true"
    text="{{ 'send_sms_nav_to_senders_help' | translate }}"
  >
  </wsb-modal>
</ng-template>
<!-- No Active Landing Page Modal -->
<ng-template #noActiveLandingModal let-c="close" let-d="dismiss">
  <wsb-modal
    title="{{ 'sms_send_pages_noactivepages_title' | translate }}"
    cancelButtonEnable="true"
    (dismiss)="d()"
    (primary)="routeToLandingPage()"
    primaryButtonText="sms_send_pages_noactivepages_gotolanding"
    text="{{ 'sms_send_pages_noactivepages' | translate }}"
  >
  </wsb-modal>
</ng-template>
